module.exports = __webpack_public_path__ + "static/media/right-hand.41c6ea6a.svg";